export default {
  headerContent: {
    title: 'Hdi Sigorta Cep Telefonu Sigortası Sorgulama',
    slogan: "Cep Telefonu Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'CEP TELEFONU SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'HDI Sigorta Cep Telefonu Sigortası Nedir?',
    description: {
      title: 'HDI Sigorta Cep Telefonu Sigortası Nedir? ',
      content: [
        'Yanınızdan bir an bile ayırmadığınız cep telefonunuzu sigortalatmayı düşündünüz mü? Yeni bir cihaz satın almayı düşünürken göz önünde bulundurmanız gereken pek çok soru var, ancak bunları henüz yanıtlamamış olabilirsiniz. Bunlardan biriside cep telefonunuzu nasıl koruma altına alabileceğinizdir.',
        'Cep telefonu sigortası, telefonunuzun başına gelebilecek risklere karşı güvence altına alan sigorta ürünüdür.',
        '<strong><em>“Çatlar masraf, kırılır masraf”</em></strong> sloganı ile öne çıkan ürün avantajları sayesinde sigortalılar tarafından pek sevildi!'
      ]
    },
    subContent: {
      title: 'HDI Sigorta Cep Telefonu Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph: 'HDI Sigortadan cep telefonu sigortası almanız sonucunda;',
          subList: [
            'Kaza sonucu hasar oluşması',
            'Ekran kırılması',
            'Yüksek voltaj kaynaklı hasar oluşması',
            'Sıvı teması sonucu hasar oluşması',
            'Hatalı aksesuar kullanımı sonrası hasar oluşması gibi durumlarda telefonunuz güvence altına alınır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Cep Telefonu Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Cep Telefonu Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Cep Telefonu Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Cep Telefonu Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Cep Telefonu Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'HDI Sigorta Cep Telefonu Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
